export default class Arbeitsplatz {
    public arbeitsplatz_id: number | null = null;
    public arbeitsplatz: string | null = null;
    public aufrufanzeige: string | null = 'n';
    public standarddrucker: string | null = null;
    public etikettendrucker: string | null = null;
    public rezeptdrucker: string | null = null;
    public cardreader_id_patient: string | null = null;
    public impfstelle_id: number | null = null;

    constructor(data?: Partial<Arbeitsplatz>) {
        Object.assign(this, data);
    }
}
